import Modal from './Modal';
import Form from './Form';
import Button from './Button';

export const ConfirmModal = Modal;
export const ConfirmForm = Form;
export const ConfirmButton = Button;

export default ConfirmButton;
